export default "__VITE_ASSET__fdn4nJDA__"